import { render } from "./Clock.vue?vue&type=template&id=4b6023dc"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4b6023dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b6023dc', script)) {
    api.reload('4b6023dc', script)
  }
  
  module.hot.accept("./Clock.vue?vue&type=template&id=4b6023dc", () => {
    api.rerender('4b6023dc', render)
  })

}

script.__file = "src/icons/components/filled/Clock.vue"

export default script